mutation deleteValuation($valuationId: ID!) {
  deleteValuation(valuationId: $valuationId) {
    id
    deletedAt
  }
}
